module.exports = __webpack_public_path__ + "img/js2.5b13b769.png";